// =============================
// common/table/Pagination.jsx
// =============================

import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
function Pagination({
  page,
  totalPages,
  onPageChange,
}) {

  return (
    <div className="d-flex align-items-center gap-3">

      <button
        className="btn btn-primary"
        disabled={page === 1}
        onClick={() =>
          onPageChange(page - 1)
        }
      >
      <FaChevronLeft/>
      </button>

      <span>
        Page {page} of {totalPages}
      </span>

      <button
        className="btn btn-primary"
        disabled={page === totalPages}
        onClick={() =>
          onPageChange(page + 1)
        }
      >
    <FaChevronRight/>
      </button>

    </div>
  );
}

export default Pagination;